module.exports = __webpack_public_path__ + "img/logo3.19e20a9a.png";